const content = {
  component: 'PageTypeA',
  cssClass: 'page-four',
  meta: {
    title: 'Crop Irrigation Ban Prompts Saudi Dairy to Expand Internationally',
    description: 'A crop irrigation ban threw agriculture company NADEC into disarray. Thankfully, cloud enabled them to evolve. ',
    og: {
      type: 'website',
      title: 'Evolving agriculture with cloud—read how',
      description: `NADEC started growing produce abroad, with the cloud able to track shipments and analyse delivery performance in real 
        time—ultimately cutting operation costs by 40%.  `,
      image: require('../../assets/images/social/og_page4.jpg')
    },
    twitter: {
      card: 'summary',
      title: 'Learn how cloud enabled an agriculture business to spread its roots.',
      description: `Agriculture company NADEC were forced to evolve after a crop irrigation ban. The business started growing produce 
        abroad, and thanks to the tracking capabilities of cloud, were able to flourish.`,
      site: '@Oracle',
      creator: '@Oracle',
      image: require('../../assets/images/social/twitter_page4.jpg')
    }
  },
  title: 'Crop Irrigation Ban Prompts Saudi Dairy to Expand Internationally',
  heroImage: {
    preload: require('../../assets/images/backgrounds/page-four-pre.jpg'),
    loaded: require('../../assets/images/backgrounds/page-four.jpg')
  },
  sections: [
    { 
      component: 'SectionQuote', 
      content: {
        quote: `Cloud applications make it possible to easily track shipments, analyse delivery performance, and reconcile payments in real time.`,
        author: `Anwar Hussain`,
        position: `CIO, NADE`,
        type: 'quote'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          A looming curb on crop irrigation in Saudi Arabia, the result of depleted groundwater reserves, has forced commercial agriculture companies such as National Agricultural Development Company (NADEC) to grow their livestock forage crops abroad.
        `,
        type: 'intro'
      }
    },
    { 
      component: 'SectionSeperator', 
      content: {
        image: null
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>NADEC, one of the largest dairy producers in the Middle East is using cloud-based technology to help it overcome the operational hurdles created by the ban. In addition to making this transformation possible, technology is also helping cut costs.</p>
          <p>NADEC started growing alfalfa and other crops for cattle feed in Sudan, Jordan, Lebanon, and other countries. These crops are then harvested and transported back to the company’s homeland dairy farm in Saudi Arabia.</p>
          <p>This has required NADEC to use new tools to communicate with shippers and fleet operators across different countries to help it overcome the operational hurdles created by the ban. However, when it discovered that its outdated IT systems weren’t up to the task, the dairy moved its logistics applications and infrastructure into the cloud.</p>
          <p>“With on-premises applications, it’s hard to collaborate with so many new business partners,” says NADEC CIO Anwar Hussain.</p>
        `,
        type: 'default'
      }
    },    
    { 
      component: 'SectionSeperator', 
      content: {
        image: require('../../assets/images/svg/truck.svg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>At alfalfa farms in Sudan, NADEC’s logistics partners load trucks with harvested feed for transport to the company’s dairy cow feed lots in Saudi Arabia. GPS tracking devices mounted on the inside windshields of each truck send data to NADEC’s Oracle Transportation Management Cloud. NADEC staff analyse the capacity of each truckload, monitor the truck’s whereabouts, and then determine travel time from Sudan to Saudi Arabia.</p>
          <p>Hussain says the cloud-based system helps NADEC identify the best shippers and determine the fastest delivery routes. Yet, what Hussain likes most about managing logistics in the cloud is that detailed information about the type of trucks, load capacities, fuelling requirements, and all of the KPIs are accessible in one place and automatically updated.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionQuote', 
      content: {
        quote: `It used to require a lot more rigor to manually reconcile shipping requirements using our old, single-dimensional capacity planning system.`,
        author: `Anwar Hussain`,
        position: `CIO, NADE`,
        type: 'quote',
        backgroundImage: require('../../assets/images/backgrounds/page-four-sub-one.jpg')
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>In the cloud, these systems are completely integrated so NADEC can track orders and then sync its manufacturing cycles and distribution schedules with the delivery promises it makes to its customers.</p>
          <p>NADEC estimates that moving its applications infrastructure to the cloud has reduced operational costs by nearly 40%. “Building our own applications infrastructure in Sudan would have required us to hire a separate IT staff, purchase new hardware, and set up a data centre facility,” says Hussain.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionImage', 
      content: {
        image: require('../../assets/images/content/page-four-a.png'),
        alt: '',
        type: 'image'
      }
    },
    { 
      component: 'SectionCopy', 
      content: {
        copy: `
          <p>For NADEC CEO Karim Manssour Dahbi, the cloud is critical for companies on the move. “When we’re able to make the best decision based on real-time intelligence, we’ll be able to benefit from each opportunity and respond immediately to changes happening in the market and within our operations.”</p>
          <p>The forage crop ban is less than one year away and NADEC is ready for the change. The dairy’s move to the cloud has allowed it to expand its operations abroad; helping ensure its new business plan based on international expansion will succeed.</p>
        `,
        type: 'default'
      }
    },
    { 
      component: 'SectionCallToAction', 
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          { 
            image: require('../../assets/images/svg/cloud-saving.svg'),
            copy: 'Finance and HR—united in the cloud',
            url: 'https://www.oracle.com/solutions/erp-hcm/mit-technology-review.html?source=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_HR_AW_HI_CM_UK_C11_Q22_EB&intcmp=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_HR_AW_HI_CM_UK_C11_Q22_EB',
            buttonCopy: 'Read iPaper '
          },
          { 
            image: require('../../assets/images/svg/graduate.svg'),
            copy: 'Uncover how to attract, develop and retain talent ',
            url: 'https://go.oracle.com/LP=43623?qt=saas_hcm_tmm_RecruitandRetainyourTalentwithOracleTalentManagementforMidsize&src1=:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_HR_CT_QT_CM_UK_C18_Q24&intcmp=WWMK170315P00034:ow:o:cs:mt:RC_EMMK180813P00039:YTTFY19_HR_CT_QT_CM_UK_C18_Q24',
            buttonCopy: 'Take our Quick Tour'
          }
        ],
        type: 'cta'
      }
    }
  ]
}

export default content;